import * as React from "react";
import { IInputFieldProps, FieldSchema, isSelectFieldSchema } from "@generation/core";
import { useFlexDirectionFormGroupContext } from "@generation/form";
import classnames from "classnames";
import { useReadContainerPropsContext } from "../Context/Read/ReadContainerPropsContextProvider";

export function withRenderFieldHoc<T extends IInputFieldProps<FieldSchema>>(
  Component: React.ComponentType<T>
) {
  const result = (props: T) => {
    const flexDirectionFormGroupControlContext = useFlexDirectionFormGroupContext();
    const defaultProps = useReadContainerPropsContext();

    const fullWidth =
      props.field.ui?.formGroupfullWidth ?? defaultProps?.uiDefaults?.formGroupfullWidth ?? false;

    const flexDirection =
      props.field.ui?.readOverview?.flexDirection ??
      props.field.ui?.flexDirection ??
      flexDirectionFormGroupControlContext;

    if (props.field.ui?.readOverview?.isNumberedListItem === true) {
      if (
        props.field.type !== "select" ||
        (isSelectFieldSchema(props.field) && props.field.multiSelect !== true)
      ) {
        return (
          <li className="read-list__item" id={props.name}>
            <Component {...props} />
          </li>
        );
      }
      return <Component {...props} />;
    }

    const classes = classnames(
      "read_item",
      `flexdirection-${flexDirection}`,
      fullWidth ? "full-width" : "",
      props.field.ui?.className ?? ""
    );

    return (
      <div className={classes} id={props.name}>
        <div className="read-item__label">{props.field.label}</div>
        <Component {...props} />
      </div>
    );
  };

  result.displayName = "WithRenderFieldHoc";

  return result;
}
